// extracted by mini-css-extract-plugin
module.exports = {"divider":"AgeGroupSelector_divider__0m36A","ageGroupSelector":"AgeGroupSelector_ageGroupSelector__Aw_H_"};